import { gql } from '@apollo/client';
import classnames from 'classnames';
import moment from 'moment';
import React from 'react';
import Avatar from '../../components/Avatar';
import Tooltip from '../../components/Tooltip';
import type {
  HistoryRow_AuthorsFragment,
  HistoryRow_VerifierFragment,
} from '../../graphql/generated/graphqlTypes';
import getUserNames from '../../user/getUserNames';
import PostIcon from '../PostIcon';
import VerifiedIcon from '../VerifiedIcon';
import styles from './HistoryRow.module.scss';

const HISTORY_ROW_AUTHORS = gql`
  fragment HistoryRow_authors on User {
    id
    ...Avatar_user
    ...getUserNames_user
  }
  ${Avatar.fragments.user}
  ${getUserNames.fragments.user}
`;

const HISTORY_ROW_VERIFIER = gql`
  fragment HistoryRow_verifier on User {
    id
    name
  }
`;

interface HistoryRowProp {
  active: boolean;
  authors?: HistoryRow_AuthorsFragment[] | null;
  verifier?: HistoryRow_VerifierFragment;
  editedAt: string;
  isCurrent: boolean;
  onClick: (e: React.MouseEvent) => void;
}

const HistoryRow = ({
  active,
  authors,
  editedAt,
  isCurrent,
  onClick,
  verifier,
}: HistoryRowProp) => {
  const classes = classnames(styles.row, { [styles.active]: active });

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited
    <div className={classes} onClick={onClick}>
      {authors?.[0] ? (
        <Avatar user={authors[0]} />
      ) : (
        <div className={styles.postIconWrapper}>
          <PostIcon />
        </div>
      )}
      <div className={styles.description}>
        {authors && (
          <div className={styles.authors}>
            {getUserNames(authors, { limit: 2 })}
          </div>
        )}
        {isCurrent ? (
          'Currently editing'
        ) : (
          <div className={styles.timestamp}>
            {moment(editedAt).format('MMM Do YYYY · h:mm A')}
          </div>
        )}
      </div>
      {verifier && (
        <Tooltip
          tooltip={`Verified by\n${verifier.name}`}
          placement="top-end"
          trigger="hover"
        >
          <VerifiedIcon />
        </Tooltip>
      )}
    </div>
  );
};

HistoryRow.fragments = {
  authors: HISTORY_ROW_AUTHORS,
  verifier: HISTORY_ROW_VERIFIER,
};

export default HistoryRow;
